
<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
};

export default {
  name: "dataAnalysis-resourceInfoUsage",
  components: {
    PageHeader: () => import("./components/header/index"),
    PageMain: () => import("./components/main"),
  },
  data() {
    return {
      table: [],
      page: {...initPage},
      loading: false,
    };
  },
  methods: {
    reset() {
      this.page = {
        ...initPage
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .dataAnalysisResourceInfoUsageList({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
};
</script>